import { useCallback } from 'react';
import { CanvasElementType, CanvasStickyNote } from '../canvas-types';
import { RfNodeStickyNote } from '../canvas-types/nodeTypesData';
import { NODE_Z_INDEX_STICKY_NOTE } from '../const/zIndex';

const emptyStickyNotesNodes: RfNodeStickyNote[] = [];

export const useStickyNotesNodesFactory = () => {
  const createFlowNodesFromSweepStickyNotesNodes = useCallback(
    ({ stickyNotesNodes }: { stickyNotesNodes?: CanvasStickyNote[] }): RfNodeStickyNote[] => {
      if (!stickyNotesNodes) {
        return emptyStickyNotesNodes;
      }
      const nodes: RfNodeStickyNote[] = [];

      stickyNotesNodes?.forEach((stickyNote) => {
        nodes.push({
          id: stickyNote.id,
          type: CanvasElementType.STICKY_NOTE,
          data: {
            color: stickyNote.color,
            richText: stickyNote.richText,
            textScale: stickyNote.textScale ?? 1,
          },
          position: stickyNote.xyPosition,
          width: stickyNote.width,
          height: stickyNote.height,
          dragHandle: '.drag-handle',
          parentId: stickyNote.sectionId,
          zIndex: NODE_Z_INDEX_STICKY_NOTE,
        });
      });

      return nodes;
    },
    [],
  );

  return {
    createFlowNodesFromSweepStickyNotesNodes,
  };
};

export default useStickyNotesNodesFactory;
